export enum TLCode {
  Add,
  AddAnchor,
  AddUser,
  ALL,
  Authorized,
  Back,
  BackToList,
  BlackPointPage,
  ByMail,
  ByPhone,
  Close,
  ContactUs,
  Days,
  DAYS,
  dummy,
  Duties,
  DUTIES,
  DutiesBackToList,
  DutiesBetweenEnd,
  DutiesBetweenStart,
  DutiesHeaderAddress,
  DutiesHeaderCity,
  DutiesHeaderDate,
  DutiesHeaderHourRange,
  DutiesHeaderPharmacyApbNumber,
  DutiesHeaderPharmacyName,
  DutiesHeaderPhoneNumber,
  DutiesHeaderZip,
  DutiesMarkerTitle,
  DutiesShowCalendar,
  DutiesShowList,
  DutiesShowOnMap,
  DutiesShowWideMap,
  DutyPage,
  DutySearchPage,
  DutyTypeDay,
  DutyTypeNight,
  Email,
  EndDate,
  ExchangePage,
  ExportAsPdf,
  FAKE,
  Firstname,
  Friday,
  GROUP,
  GroupPage,
  HomePage,
  Lastname,
  LEVEL3,
  Monday,
  NA,
  NewPassword,
  NewPasswordConfirmation,
  Nights,
  NONE,
  OneDay,
  OneMonth,
  OneWeek,
  OneYear,
  OR,
  Password,
  PHARMACIES,
  PHARMACY,
  PharmacyPage,
  Pharmamove,
  PlannerPage,
  PubliGarde,
  REFRESH,
  Rejected,
  Role,
  Roles,
  Saturday,
  SearchAPBOrNamePlaceholder,
  SearchPharmacyAddressPlaceholder,
  SECRETARIAT,
  SecretariatPage,
  SelectADay,
  SOME,
  StartDate,
  SUBMIT,
  Sunday,
  Thursday,
  Today,
  TransferPage,
  Tuesday,
  USER,
  UserGuideManual,
  Username,
  UserPage,
  Wednesday,
  ABNORMAL_DUTY_COUNTS,
  ABNORMAL_DUTY_COUNTS_APBNUMBER,
  ABNORMAL_DUTY_COUNTS_COUNT,
  ABNORMAL_DUTY_COUNTS_DAY_COUNT,
  ABNORMAL_DUTY_COUNTS_DAY_TARGET_COUNT,
  ABNORMAL_DUTY_COUNTS_DETAILS,
  ABNORMAL_DUTY_COUNTS_DUTY_COUNT_PREV_SEM,
  ABNORMAL_DUTY_COUNTS_NAME,
  ABNORMAL_DUTY_COUNTS_NIGHT_COUNT,
  ABNORMAL_DUTY_COUNTS_NIGHT_TARGET_COUNT,
  ABNORMAL_DUTY_COUNTS_PHARMACY,
  ABNORMAL_DUTY_COUNTS_TARGET_COUNT,
  AMONG_WHICH,
  ANALYSIS_Assess,
  ANALYSIS_CLICK_SEMESTER,
  ANALYSIS_END,
  ANALYSIS_Enhance,
  ANALYSIS_GLOBAL_PERF,
  ANALYSIS_GLOBAL_PERF_COMMENT,
  ANALYSIS_LargeGaps,
  ANALYSIS_LOWER_DISTANCE_LIMIT,
  ANALYSIS_LOWER_GAP_LIMIT,
  ANALYSIS_MAIN_TITLE,
  ANALYSIS_MATCHES,
  ANALYSIS_MATCHES_APPNUMBER,
  ANALYSIS_MATCHES_COUNT,
  ANALYSIS_MATCHES_CURR,
  ANALYSIS_MATCHES_DESCRIPTION,
  ANALYSIS_MATCHES_HARD,
  ANALYSIS_MATCHES_MED,
  ANALYSIS_MATCHES_NAME,
  ANALYSIS_MATCHES_NEXT,
  ANALYSIS_MATCHES_PREV,
  ANALYSIS_MATCHES_RULE,
  ANALYSIS_MATCHES_SOFT,
  ANALYSIS_MATCHES_TRANSGRESSIONS,
  ANALYSIS_MENU_ENTRY,
  ANALYSIS_OFFSET,
  ANALYSIS_PERF,
  ANALYSIS_PERIOD,
  ANALYSIS_PERIOD_UNTIL,
  ANALYSIS_PLANNINGID,
  ANALYSIS_PREVPLANNINGID,
  ANALYSIS_PROBLEMS,
  ANALYSIS_RULES,
  ANALYSIS_SCORES,
  ANALYSIS_SCORES_CALCSTART,
  ANALYSIS_SCORES_DESCRIPTION,
  ANALYSIS_SCORES_DURATION,
  ANALYSIS_SCORES_END,
  ANALYSIS_SCORES_HARD,
  ANALYSIS_SCORES_ID,
  ANALYSIS_SCORES_LASTPROMOTED,
  ANALYSIS_SCORES_MED,
  ANALYSIS_SCORES_NAME,
  ANALYSIS_SCORES_PLANNINGID,
  ANALYSIS_SCORES_RUNID,
  ANALYSIS_SCORES_SOFT,
  ANALYSIS_SCORES_START,
  ANALYSIS_SCORES_STATUS,
  ANALYSIS_SCORES_TIMESTAMP,
  ANALYSIS_SmallGaps,
  ANALYSIS_START,
  ANALYSIS_STATUS,
  ANALYSIS_TRANSGRESSIONS,
  ANALYSIS_TRANSGRESSIONS_DETAIL,
  ANALYSIS_TRANSGRESSIONS_ID,
  ANALYSIS_UPPER_GAP_LIMIT,
  ANCHOR_Color,
  ANCHOR_Delete_Confirmation_Dialog_Message,
  ANCHOR_Delete_Confirmation_Dialog_Title,
  ANCHOR_Group,
  ANCHOR_Lat,
  ANCHOR_Long,
  ANCHOR_Name,
  ANCHOR_Radius,
  ANCHOR_SelectPharmacies,
  ANCHOR_Subtitle_Edit,
  ANCHOR_Subtitle_New,
  ANCHORGROUP_No_anchors,
  BANK_HOLIDAY_DATES_Title,
  BANK_HOLIDAYS_Button,
  BLACKPOINT_Choose_Type,
  BLACKPOINT_Comment,
  BLACKPOINT_DETAIL_Approuved,
  BLACKPOINT_DETAIL_Days,
  BLACKPOINT_DETAIL_Refused,
  BLACKPOINT_DETAIL_Submitted,
  BLACKPOINT_Pharmacy,
  BLACKPOINT_Search_Date,
  BLACKPOINT_Title,
  BLACKPOINT_ToProcess,
  BLACKPOINT_Type,
  BLACKPOINTS_EcoCnt,
  BLACKPOINTS_EcoCntS1,
  BLACKPOINTS_EcoCntS2,
  BLACKPOINTS_EmptyList,
  BLACKPOINTS_FilterOnTcOrSpecs,
  BLACKPOINTS_FilterOnTcOrSpecs_All,
  BLACKPOINTS_FilterOnTcOrSpecs_Tooltip,
  BLACKPOINTS_FilterOnTcOrSpecsS1,
  BLACKPOINTS_FilterOnTcOrSpecsS1_Tooltip,
  BLACKPOINTS_FilterOnTcOrSpecsS2,
  BLACKPOINTS_FilterOnTcOrSpecsS2_Tooltip,
  BLACKPOINTS_HolCnt,
  BLACKPOINTS_HolCnt_All,
  BLACKPOINTS_HolCnt_Any,
  BLACKPOINTS_HolCnt_None,
  BLACKPOINTS_HolCnt_Some,
  BLACKPOINTS_HolCntFilterLabel,
  BLACKPOINTS_HolCntS1,
  BLACKPOINTS_HolCntS2,
  BLACKPOINTS_LevelFilterLabel,
  BLACKPOINTS_PageTitle,
  BLACKPOINTS_SickCnt,
  BLACKPOINTS_SickCntS1,
  BLACKPOINTS_SickCntS2,
  BLACKPOINTS_SpecCnt,
  BLACKPOINTS_SpecCntS1,
  BLACKPOINTS_SpecCntS2,
  BLACKPOINTS_Title,
  BLACKPOINTS_TitleNoCriteria,
  BLACKPOINTS_TitleToProcessed,
  CALENDAR_COMPARISON_PAGE,
  CALENDAR_Confirmation_BP_Exemption_Duty_Text,
  CALENDAR_Confirmation_BP_Exemption_Duty_Title,
  CANDIDATES_DIALOG_TITLE,
  CHOOSE_A_DAY,
  CHOOSE_A_GROUP,
  CHOOSE_A_LANGUAGE,
  CHOOSE_A_PHARMACY,
  CHOOSE_A_PHARMACY_STATUS,
  CHOOSE_A_SECRETARIAT,
  CHOOSE_A_STATUS,
  CHOOSE_A_TYPE,
  CHOOSE_A_USER,
  CHOOSE_AN_ANCHOR,
  DISCREPENCIES_EndDate,
  DISCREPENCIES_FieldType,
  DISCREPENCIES_NewAfmps,
  DISCREPENCIES_NewApb,
  DISCREPENCIES_OldAfmps,
  DISCREPENCIES_OldApb,
  DISCREPENCIES_StartDate,
  DISTANCES_Address,
  DISTANCES_Anchor,
  DISTANCES_ApbNumber,
  DISTANCES_City,
  DISTANCES_Date,
  DISTANCES_Distance,
  DISTANCES_Group,
  DISTANCES_Name,
  DISTANCES_TITLE,
  DISTANCES_Zip,
  DISTANCES_PairingAllowed,
  DOUBLE_CALENDAR_ReopenListOfCandidates,
  DUTIES_AllDuties,
  DUTIES_CheckAllGroups,
  DUTIES_Close,
  DUTIES_Date_Conflict_BP,
  DUTIES_Date_Conflict_Date_Detail,
  DUTIES_Date_Conflict_Duty,
  DUTIES_Date_Conflict_DutyOff,
  DUTIES_Date_Conflicts_Btn,
  DUTIES_Date_Conflicts_Explanation,
  DUTIES_Date_Conflicts_Title,
  DUTIES_Date_Selected_For_Candidates_Title,
  DUTIES_DAY_AND_NIGHT_COUNTER,
  DUTIES_Duties,
  DUTIES_Level0,
  DUTIES_Others,
  DUTIES_ShowAnchors,
  DUTIES_ShowDayDuties,
  DUTIES_ShowNightDuties,
  DUTIES_ShowOtherPharmacies,
  DUTIES_ShowPharmaciesDuty30KmCircle,
  DUTIES_ShowPharmaciesDutyCircle,
  DUTIES_ToggleSelectedGroups,
  DUTIES_TransferDialog_Blocked_Explained,
  DUTIES_TransferDialog_DatesToTransfer,
  DUTIES_TransferDialog_From,
  DUTIES_TransferDialog_FromDate,
  DUTIES_TransferDialog_To,
  DUTIES_TransferDialog_ToDate,
  DUTIES_TransferDialog_TransferBtn,
  DUTIES_TransferDialog_TransferBtn_Explained,
  DUTIES_TransferDialogTitle,
  DUTIES_UncheckAllGroups,
  DutiesShowWideMap_Short,
  DUTY_COUNT_CHANGES_APBNUMBER,
  DUTY_COUNT_CHANGES_CURRALL,
  DUTY_COUNT_CHANGES_CURRDAY,
  DUTY_COUNT_CHANGES_CURRDAYONLY,
  DUTY_COUNT_CHANGES_CURRDAYONLY_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRENT_RATIO,
  DUTY_COUNT_CHANGES_CURRNBR_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRNIGHT,
  DUTY_COUNT_CHANGES_CURRNIGHT_TOOLTIP,
  DUTY_COUNT_CHANGES_CURRRATIO_TOOLTIP,
  DUTY_COUNT_CHANGES_DIFFERENCE,
  DUTY_COUNT_CHANGES_DIFFERENCE_TOOLTIP,
  DUTY_COUNT_CHANGES_EXPLANATION_1,
  DUTY_COUNT_CHANGES_EXPLANATION_2,
  DUTY_COUNT_CHANGES_EXPLANATION_3,
  DUTY_COUNT_CHANGES_EXPLANATION_4,
  DUTY_COUNT_CHANGES_GRAPHS_TITLE,
  DUTY_COUNT_CHANGES_GROUP_DAY_TARGET,
  DUTY_COUNT_CHANGES_GROUP_NIGHT_TARGET,
  DUTY_COUNT_CHANGES_GROUP_TARGET,
  DUTY_COUNT_CHANGES_GROUP_TARGET_DIFFERENCE,
  DUTY_COUNT_CHANGES_LIST_TITLE,
  DUTY_COUNT_CHANGES_PHARMACY_NAME,
  DUTY_COUNT_CHANGES_PHARMACYID,
  DUTY_COUNT_CHANGES_PHARMACYID_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVALL,
  DUTY_COUNT_CHANGES_PREVDAY,
  DUTY_COUNT_CHANGES_PREVDAYONLY,
  DUTY_COUNT_CHANGES_PREVDAYONLY_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVIOUS_RATIO,
  DUTY_COUNT_CHANGES_PREVNBR_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVNIGHT,
  DUTY_COUNT_CHANGES_PREVNIGHT_TOOLTIP,
  DUTY_COUNT_CHANGES_PREVRATIO_TOOLTIP,
  DUTY_COUNT_CHANGES_TITLE,
  DUTYASSIGNMENT_AddDuty,
  DUTYASSIGNMENT_Date,
  DUTYASSIGNMENT_DAY,
  DUTYASSIGNMENT_DAY_AND_NIGHT,
  DUTYASSIGNMENT_DAY_OF_WEEK,
  DUTYASSIGNMENT_DAY_PLUS_NIGHT,
  DUTYASSIGNMENT_DAY_SINGLE,
  DUTYASSIGNMENT_DAY_ZONES,
  DUTYASSIGNMENT_DAY_ZONES2,
  DUTYASSIGNMENT_DutiesGeneration,
  DUTYASSIGNMENT_DutiesSamePeriod,
  DUTYASSIGNMENT_Exclusion,
  DUTYASSIGNMENT_Exclusion_Detail,
  DUTYASSIGNMENT_Exclusion_Explanation,
  DUTYASSIGNMENT_LEVEL1,
  DUTYASSIGNMENT_LEVEL3,
  DUTYASSIGNMENT_Next,
  DUTYASSIGNMENT_NIGHT,
  DUTYASSIGNMENT_NIGHT_SINGLE,
  DUTYASSIGNMENT_NIGHT_ZONES,
  DUTYASSIGNMENT_NIGHT_ZONES2,
  DUTYASSIGNMENT_NotifySecretariat,
  DUTYASSIGNMENT_Pharmacy,
  DUTYASSIGNMENT_SaveDuties,
  DUTYASSIGNMENT_SelectPharmacy,
  DUTYASSIGNMENT_Title,
  DUTYASSIGNMENT_TOTAL,
  DUTYASSIGNMENT_Type,
  DUTYASSIGNMENT_ViewOnlyNeighbor,
  PLANNINGUPLOAD_Title,
  PLANNINGUPLOAD_DragAndDrop,
  PLANNINGUPLOAD_DragAndDrop_Example,
  DUTYDOWNLOAD_Title,
  DUTYDOWNLOAD_WarningSecretariatDownLoadDuties_Admin,
  DUTYDOWNLOAD_WarningSecretariatDownLoadDuties_SuperAdmin,
  DUTYMAP_S1,
  DUTYMAP_S2,
  DUTYUPLOAD_DragAndDrop,
  DUTYUPLOAD_DragAndDrop_Example,
  DUTYUPLOAD_Title,
  ERROR_NoPharmacyRelatedToThisUser,
  ERROR_NoSecretariatRelatedToThisUser,
  ERROR_PAGE_Title,
  ERROR_REQUIRED_FIELD,
  ERROR_VALUE_TOO_LONG,
  EXCHANGE_Confirmation_Button,
  EXCHANGE_Confirmation_Message,
  EXCHANGE_Confirmation_Message_Detail,
  EXCHANGE_Confirmation_Message_Detail_Day,
  EXCHANGE_Confirmation_Message_Detail_Day_Night,
  EXCHANGE_Confirmation_Message_Detail_Night,
  EXCHANGE_Confirmation_Message_Mail,
  EXCHANGE_Confirmation_Title,
  EXCHANGE_ConflictDutyDate,
  EXCHANGE_ConflictDutyTooClose,
  EXCHANGE_ConflictDutyTooClose_ByPass,
  EXCHANGE_ConflictPharmacy,
  EXCHANGE_ConflictSecretariat,
  EXCHANGE_DUTIES_AsTheCrowFlies,
  EXCHANGE_DUTIES_CARD_TITLE,
  EXCHANGE_DUTIES_DownloadWarningDisabled,
  EXCHANGE_DUTIES_NoAcceptablePharmacy,
  EXCHANGE_HISTORY_Date,
  EXCHANGE_HISTORY_Day,
  EXCHANGE_HISTORY_DutyDate,
  EXCHANGE_HISTORY_DutyType,
  EXCHANGE_HISTORY_LastGeoWachtUpload,
  EXCHANGE_HISTORY_LoadPastDate,
  EXCHANGE_HISTORY_Night,
  EXCHANGE_HISTORY_Recipient,
  EXCHANGE_HISTORY_REGISTERED_BY,
  EXCHANGE_HISTORY_Sender,
  EXCHANGE_HISTORY_StartDate,
  EXCHANGE_HistoryTabTitle,
  EXCHANGE_NeighborDutiesReinitialisation,
  EXCHANGE_NewExchangeTabTitle,
  EXCHANGE_PHARMACY_OTHER_CARD_TITLE,
  EXCHANGE_PHARMACY_REQUESTER_CARD_TITLE,
  EXCHANGE_Preview,
  EXCHANGE_Remark,
  EXCHANGE_Save,
  EXCHANGE_SelectionType_ByDate,
  EXCHANGE_SelectionType_ByDayOfWeek,
  EXCHANGE_SelectionType_ByPharmacy,
  EXCHANGE_Title,
  EXCHANGE_WithAgreement,
  EXCHANGE_WithAgreementMessage,
  EXCHANGE_WithoutSubstitutionMessage,
  EXCHANGE_WithSubstitution,
  FILE_LOADING_MODAL_MUNICIPALITIES_TITLE,
  FILE_LOADING_MODAL_POPULATION_TITLE,
  FILE_LOADING_MODAL_ZIP_CODE_TITLE,
  FILE_UPLOAD_ERROR_MESSAGE,
  FILE_UPLOAD_SUCCESSFULLY_IMPORT,
  FILTER_All,
  FORM_FIELD_REQUIRED_LABEL,
  FORM_FIELD_VALIDATION_REGEX,
  FORM_FIELD_VALIDATION_REQUIRED,
  GENERAL_Add,
  GENERAL_Bankholiday,
  GENERAL_Cancel,
  GENERAL_Close,
  GENERAL_Confirm,
  GENERAL_ConfirmationDemand,
  GENERAL_Delete,
  GENERAL_Edit,
  GENERAL_Force,
  GENERAL_Mark,
  GENERAL_NextDay,
  GENERAL_NextYear,
  GENERAL_PreviousDay,
  GENERAL_Print,
  GENERAL_Refresh,
  GENERAL_Reset,
  GENERAL_Save,
  GENERAL_Search,
  GENERAL_Select,
  GENERAL_Send,
  GENERAL_Today,
  GENERAL_Validate,
  GENERAL_Verify,
  GENERAL_Warning,
  GRID_EXCEL_EXPORT,
  GRID_NUMBER_RESULT,
  GROUP_ActiveMemberCount,
  GROUP_Add,
  GROUP_CheckDutyOffRequests,
  GROUP_ClosedMemberCount,
  GROUP_Color,
  GROUP_Description,
  GROUP_Display,
  GROUP_Edit,
  GROUP_LimitExchangeToAnchor,
  GROUP_MemberCount,
  GROUP_Name,
  GROUP_RefreshGeodata,
  GROUP_RegisterMembers,
  GROUP_Secretariat,
  GROUP_TargetCounts,
  GROUP_TargetDayDutyCount,
  GROUP_TargetDutyCount,
  GROUP_TargetNightDutyCount,
  GROUP_TemporarilyClosedMemberCount,
  GROUPANALYSIS_AVERAGE,
  GROUPANALYSIS_CALCULATE,
  GROUPANALYSIS_COUNT,
  GROUPANALYSIS_DATE,
  GROUPANALYSIS_DAY_COUNT,
  GROUPANALYSIS_DUTY_COUNTS_BY_DATE,
  GROUPANALYSIS_DUTY_COUNTS_TAB,
  GROUPANALYSIS_DUTY_COUNTS_TITLE,
  GROUPANALYSIS_DYNAMIC_TRANSGRESSIONS,
  GROUPANALYSIS_GROUP,
  GROUPANALYSIS_GROUP_AVERAGE_DUTY_COUNTS,
  GROUPANALYSIS_GROUP_TARGETS_TITLE,
  GROUPANALYSIS_GROUP_TRANSGRESSIONS_BY_DATE,
  GROUPANALYSIS_GROUP_TRANSGRESSIONS_TITLE,
  GROUPANALYSIS_MEMBERS,
  GROUPANALYSIS_NIGHT_COUNT,
  GROUPANALYSIS_TARGET,
  GROUPANALYSIS_TARGET_DAY,
  GROUPANALYSIS_TARGET_NIGHT,
  GROUPANALYSIS_TARGET_TOTAL,
  GROUPANALYSIS_TITLE,
  GROUPANALYSIS_WEEKDAY,
  GROUPANALYSIS_WEEKDAY1,
  GROUPANALYSIS_WEEKDAY2,
  GROUPS_NewMembers,
  GROUPS_Target,
  GROUPS_Title,
  HANGFIRE_Start,
  HANGFIRE_Stop,
  HOME_Title,
  INSUFICIENT_GEO_COVERAGE,
  IS_ACTIVE,
  LEVEL_Accept,
  LEVEL_Reject,
  LOGIN_AuthenticationError,
  LOGIN_EmailAPB,
  LOGIN_Login,
  LOGIN_NewPassword,
  LOGIN_NewPasswordError,
  LOGIN_NewPasswordProgressTitle,
  LOGIN_NewPasswordReturnPage,
  LOGIN_NewPasswordSent,
  LOGIN_Password,
  LOGIN_PreferredBrowsers,
  LOGIN_RequestNewPassword,
  LOGIN_RequestNewPasswordError,
  LOGIN_RequestNewPasswordProgressTitle,
  LOGIN_RequestNewPasswordSent,
  MEDIASANTE_nbRecords,
  MEDIASANTE_TAB_Json,
  MEDIASANTE_TAB_Table,
  MEDIASANTE_TABLE_Address,
  MEDIASANTE_TABLE_ApbNumber,
  MEDIASANTE_TABLE_City,
  MEDIASANTE_TABLE_Date,
  MEDIASANTE_TABLE_Group,
  MEDIASANTE_TABLE_Name,
  MEDIASANTE_TABLE_Phone,
  MEDIASANTE_TABLE_Secretariat,
  MEDIASANTE_TABLE_Type,
  MEDIASANTE_TABLE_ZipCode,
  MESSAGE_AttachmentList,
  MESSAGE_Attachments,
  MESSAGE_Body,
  MESSAGE_Confirmation_Preview_Error,
  MESSAGE_Confirmation_Preview_Message,
  MESSAGE_Confirmation_Preview_Title,
  MESSAGE_Content,
  MESSAGE_Date,
  MESSAGE_DragAndDrop,
  MESSAGE_NewAnswer,
  MESSAGE_NewMessage,
  MESSAGE_OneDay,
  MESSAGE_Preview,
  MESSAGE_Recipient,
  MESSAGE_RECIPIENTS_Affiliates_1,
  MESSAGE_RECIPIENTS_Affiliates_3,
  MESSAGE_RECIPIENTS_Affiliates_All,
  MESSAGE_RECIPIENTS_All,
  MESSAGE_RECIPIENTS_DayNightDuty,
  MESSAGE_RECIPIENTS_DayOnlyDuty,
  MESSAGE_RECIPIENTS_DutyDate,
  MESSAGE_RECIPIENTS_Group_one,
  MESSAGE_RECIPIENTS_Group_several,
  MESSAGE_RECIPIENTS_Neighbors,
  MESSAGE_RECIPIENTS_Neighbors_radius,
  MESSAGE_RECIPIENTS_NightOnlyDuty,
  MESSAGE_RECIPIENTS_One,
  MESSAGE_RECIPIENTS_PharmaciesOnDuty,
  MESSAGE_RECIPIENTS_Several,
  MESSAGE_RECIPIENTS_Test,
  MESSAGE_Send_to_table_result,
  MESSAGE_Sender,
  MESSAGE_TabTitle,
  MESSAGE_TestEmailAddress,
  MESSAGE_TestMessage,
  MESSAGE_Title,
  MESSAGE_Type,
  MISSING_BLACKPOINTS_Filter,
  MISSING_BLACKPOINTS_FilterAll,
  MISSING_BLACKPOINTS_FilterComplete,
  MISSING_BLACKPOINTS_FilterEmpty,
  MISSING_BLACKPOINTS_FilterPartial,
  MISSING_BLACKPOINTS_NumberBP,
  MISSING_BLACKPOINTS_Title,
  MULTI_CALENDAR_ErrorMsgEncodingNotOpenForThisDate,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPoints,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnBankHolidays,
  MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnWeekends,
  MULTI_CALENDAR_ErrorMsgTooManyEconomicBlackPoints,
  MULTI_CALENDAR_InfoMsgAlreadyExempted,
  MULTI_CALENDAR_Legend,
  MULTI_CALENDAR_LimitSelectionToGroupOfFirstPickedPharmacy,
  MULTI_CALENDAR_MsgYouHaveReachedQuota,
  MULTI_CALENDAR_NoSecretariatSelected,
  MULTI_CALENDAR_REMOVE_EXEMPTION_CONTENT,
  MULTI_CALENDAR_REMOVE_EXEMPTION_TITLE,
  MULTI_CALENDAR_Toolbox,
  MULTI_CALENDAR_TOOLBOX_BankHoliday,
  MULTI_CALENDAR_TOOLBOX_BankHolidayDutyOffRequest,
  MULTI_CALENDAR_TOOLBOX_BankHolidayShort,
  MULTI_CALENDAR_TOOLBOX_BlackPointEconomic,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingClosed,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingOpen,
  MULTI_CALENDAR_TOOLBOX_BlackPointEncodingStatus,
  MULTI_CALENDAR_TOOLBOX_BlackPointHoliday,
  MULTI_CALENDAR_TOOLBOX_BlackPointSick,
  MULTI_CALENDAR_TOOLBOX_BlackPointSpecial,
  MULTI_CALENDAR_TOOLBOX_BlackPointSpecialDeactivate,
  MULTI_CALENDAR_TOOLBOX_Candidates,
  MULTI_CALENDAR_TOOLBOX_DutyDay,
  MULTI_CALENDAR_TOOLBOX_DutyDayNight,
  MULTI_CALENDAR_TOOLBOX_DutyNight,
  MULTI_CALENDAR_TOOLBOX_EncodingIsPossible,
  MULTI_CALENDAR_TOOLBOX_Erase,
  MULTI_CALENDAR_TOOLBOX_ExchangeDuty,
  MULTI_CALENDAR_TOOLBOX_Inactive,
  MULTI_CALENDAR_TOOLBOX_Modification,
  MULTI_CALENDAR_TOOLBOX_NextYear,
  MULTI_CALENDAR_TOOLBOX_NrBlackPoint,
  MULTI_CALENDAR_TOOLBOX_NrBlackPointInfo,
  MULTI_CALENDAR_TOOLBOX_NrFreeBankHolidayBalance,
  MULTI_CALENDAR_TOOLBOX_NrFreeEconomicBlackpoint,
  MULTI_CALENDAR_TOOLBOX_NrFreeWeekendBalance,
  MULTI_CALENDAR_TOOLBOX_PreviousYear,
  MULTI_CALENDAR_TOOLBOX_QuotaHelp,
  MULTI_CALENDAR_TOOLBOX_S1,
  MULTI_CALENDAR_TOOLBOX_S2,
  MULTI_CALENDAR_TOOLBOX_ThisYear,
  MULTI_CALENDAR_TOOLBOX_Today,
  MULTI_CALENDAR_TOOLBOX_Transfert,
  MULTI_CALENDAR_Transfert_Warning_Content,
  MULTI_CALENDAR_Transfert_Warning_Title,
  MULTI_CALENDAR_Warning_Close,
  MUNICIPALITY_Choose,
  MUNICIPALITY_Edit,
  MUNICIPALITY_EntityNameFr,
  MUNICIPALITY_EntityNameNl,
  MUNICIPALITY_Id,
  MUNICIPALITY_Ins5Code,
  MUNICIPALITY_INS6Code,
  MUNICIPALITY_IsMain,
  MUNICIPALITY_MainMunicipalityFr,
  MUNICIPALITY_MainMunicipalityNl,
  MUNICIPALITY_Population,
  MUNICIPALITY_PostalCode,
  MUNICIPALITY_Selection_Message,
  MY_PHARMACY,
  ON_A_TOTAL_OF,
  PHARMACIES_Active,
  PHARMACIES_ActivityStatus,
  PHARMACIES_Address,
  PHARMACIES_All_F,
  PHARMACIES_All_M,
  PHARMACIES_Anchor,
  PHARMACIES_ApbNum,
  PHARMACIES_ApbNum2,
  PHARMACIES_BackToList,
  PHARMACIES_City,
  PHARMACIES_Density,
  PHARMACIES_Distance,
  PHARMACIES_Exchanges,
  PHARMACIES_Group,
  PHARMACIES_Groups,
  PHARMACIES_Help,
  PHARMACIES_Inactive,
  PHARMACIES_Level,
  PHARMACIES_Limitrophes,
  PHARMACIES_LoadList,
  PHARMACIES_Municipality,
  PHARMACIES_MySecretariat,
  PHARMACIES_One,
  PHARMACIES_Pairing,
  PHARMACIES_Pharmacist,
  PHARMACIES_PharmacyName,
  PHARMACIES_Search_Help,
  PHARMACIES_Secretariat,
  PHARMACIES_Secretariats,
  PHARMACIES_Standard,
  PHARMACIES_Status,
  PHARMACIES_Three,
  PHARMACIES_Title,
  PHARMACIES_User,
  PHARMACIES_Zero,
  PHARMACIES_ZipCode,
  PHARMACIES_Zone,
  PHARMACY_Anchor,
  PHARMACY_ApbNr,
  PHARMACY_BlackPointList,
  PHARMACY_CALENDAR_Comment,
  PHARMACY_Calendar_SharedDutiesGroup_Info,
  PHARMACY_CalendarComparison,
  PHARMACY_Capital,
  PHARMACY_CheckDutyOffRequests,
  PHARMACY_DayMaxDistance,
  PHARMACY_DayMinDistance,
  PHARMACY_Density,
  PHARMACY_Details,
  PHARMACY_DUTIES_Address,
  PHARMACY_DUTIES_ApbNumber,
  PHARMACY_DUTIES_Date,
  PHARMACY_DUTIES_Explanation_1,
  PHARMACY_DUTIES_Hour,
  PHARMACY_DUTIES_Pharmacy,
  PHARMACY_DUTIES_Phone,
  PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Cancel,
  PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Confirm,
  PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Message,
  PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Title,
  PHARMACY_DUTY_ROSTER_AllRoster,
  PHARMACY_DUTY_ROSTER_DE,
  PHARMACY_DUTY_ROSTER_Download,
  PHARMACY_DUTY_ROSTER_FR,
  PHARMACY_DUTY_ROSTER_From,
  PHARMACY_DUTY_ROSTER_Language,
  PHARMACY_DUTY_ROSTER_NumWeek,
  PHARMACY_DUTY_ROSTER_Print,
  PHARMACY_DUTY_ROSTER_Print_DE,
  PHARMACY_DUTY_ROSTER_Print_FR,
  PHARMACY_DUTY_ROSTER_RosterNextWeek,
  PHARMACY_DUTY_ROSTER_RosterThisWeek,
  PHARMACY_DUTY_ROSTER_To,
  PHARMACY_DutyCalendar,
  PHARMACY_DutyCalendarComparator,
  PHARMACY_DutyList,
  PHARMACY_DutyMap,
  PHARMACY_DutyRoster,
  PHARMACY_ExchangeHistory_popup_OPEN,
  PHARMACY_ExchangeHistory_popup_Title,
  PHARMACY_FILTER_NOTICE,
  PHARMACY_Goto_User,
  PHARMACY_Group,
  PHARMACY_GroupDutyList,
  PHARMACY_History,
  PHARMACY_IsContributing,
  PHARMACY_Language,
  PHARMACY_Latitude,
  PHARMACY_Level,
  PHARMACY_LINKS_NOTICE,
  PHARMACY_LINKS2_NOTICE,
  PHARMACY_Longitude,
  PHARMACY_Map,
  PHARMACY_Map_Exclusion_Day_checkbox,
  PHARMACY_Map_Exclusion_Night_checkbox,
  PHARMACY_Map_Legend_neighborIcon,
  PHARMACY_Map_Legend_pharmacyIcon,
  PHARMACY_Map_Legend_sameSecretariatNeighborIcon,
  PHARMACY_Mobile,
  PHARMACY_Neighborhood,
  PHARMACY_NightMaxDistance,
  PHARMACY_NightMinDistance,
  PHARMACY_Phone,
  PHARMACY_PrefDayOff,
  PHARMACY_PrefDayOn,
  PHARMACY_ReapplyDefaultExchangeFlags_Btn,
  PHARMACY_ReapplyDefaultExchangeFlags_ToolTip,
  PHARMACY_ReapplyDefaultPairingFlags_Btn,
  PHARMACY_ReapplyDefaultPairingFlags_ToolTip,
  PHARMACY_RecalculateDefaultExchangeFlags_Btn,
  PHARMACY_RecalculateDefaultExchangeFlags_ToolTip,
  PHARMACY_RecalculateDefaultPairingFlags_Btn,
  PHARMACY_RecalculateDefaultPairingFlags_ToolTip,
  PHARMACY_RecalculateExchangeAllowed_Lbl,
  PHARMACY_RecalculatePairingAllowed_Lbl,
  PHARMACY_ReceivesSms,
  PHARMACY_RefreshGeoData,
  PHARMACY_SharedDutiesGroup_Btn,
  PHARMACY_SharedDutiesGroup_Dialog_Select,
  PHARMACY_SharedDutiesGroup_Dialog_Title,
  PHARMACY_Status,
  PHARMACY_STATUS_ACTIVE,
  PHARMACY_STATUS_PERM_CLOSED,
  PHARMACY_STATUS_TEMP_CLOSED,
  PHARMACY_Title,
  PHARMACY_ToggleExchangeConfirmationMessage,
  PHARMACY_TogglePairingConfirmationMessage,
  PHARMACY_ToggleRemoveExchangeConfirmationMessage,
  PHARMACY_ToggleRemovePairingConfirmationMessage,
  PHARMACY_X_Lambert2008,
  PHARMACY_Y_Lambert2008,
  PHARMACY_Zone,
  PLANNER_ERROR_MESSAGE,
  PLANNER_FILE_LOADING_MODAL_TITLE,
  PLANNER_FILE_SUCCESSFULLY_IMPORT,
  PLANNER_Title,
  PROTECTION_Duration,
  PROTECTION_EndDate,
  PROTECTION_Latitude,
  PROTECTION_Longitude,
  PROTECTION_Range,
  PROTECTION_StartDate,
  PROTECTION_Status,
  PROTECTION_Terminate,
  PROTECTION_Type,
  PUSH_NOTIFICATION_Push,
  QUICK_DUTY_PAGE,
  REFRESH_GEO_DATA_Done,
  REFRESH_GEO_DATA_Error,
  REFRESH_GEO_DATA_Title,
  ROSTER_AddSixWeeks,
  ROSTER_CalculateAnnualReviews,
  ROSTER_CalculateNeighborhoods,
  ROSTER_CheckDutyOffRequests,
  ROSTER_CheckMissingBlackPoints,
  ROSTER_CloseBlackPointEncoding,
  ROSTER_ConstructionHeuristicDuration,
  ROSTER_COPYBP,
  ROSTER_CopyBPOrDuties,
  ROSTER_COPYLVL1DUTIES,
  ROSTER_DeleteConfirmationText,
  ROSTER_DeleteConfirmationTitle,
  ROSTER_DeletePlanning,
  ROSTER_DeserializeConfirmationText,
  ROSTER_DeserializeConfirmationTitle,
  ROSTER_DownloadAddedDutyAssignmentsButton,
  ROSTER_DownloadDutyAssignments,
  ROSTER_DownloadDutyAssignmentsButton,
  ROSTER_ExplainScore,
  ROSTER_FileLinesLimit,
  ROSTER_Geowacht,
  ROSTER_GeowachtDownloadDutyAssignments,
  ROSTER_GetScore,
  ROSTER_GetStatus,
  ROSTER_GoogleMapsMaxCalls,
  ROSTER_ImportPharmacy,
  ROSTER_InitializeDownloadAdjacentPharmacyData,
  ROSTER_InitializeDownloadPharmacyData,
  ROSTER_OpenPlannerPanel,
  ROSTER_PromoteConfirmationText,
  ROSTER_PromoteConfirmationTitle,
  ROSTER_PromotePlanning,
  ROSTER_PublishConfirmationText,
  ROSTER_PublishConfirmationTitle,
  ROSTER_PublishPlanning,
  ROSTER_Reconnect,
  ROSTER_ReloadScores,
  ROSTER_ReloadSolution,
  ROSTER_ReplicateLevel1DutyAssignments,
  ROSTER_Resume,
  ROSTER_S1,
  ROSTER_S2,
  ROSTER_SaveConfirmationText,
  ROSTER_SaveConfirmationTitle,
  ROSTER_SaveDutyAssignments,
  ROSTER_SavePlanning,
  ROSTER_SavePlanningData,
  ROSTER_Semester,
  ROSTER_SemesterNotSelected,
  ROSTER_SemesterSelected,
  ROSTER_SerializeSolution,
  ROSTER_ShowExplanation,
  ROSTER_ShowIndictments,
  ROSTER_ShowMatches,
  ROSTER_Start,
  ROSTER_TakeSnapshot,
  ROSTER_AssessPlanning,
  ROSTER_Stop,
  ROSTER_Suspend,
  ROSTER_Title,
  ROSTER_UploadDuties,
  ROSTER_UploadDutyAssignmentsButton,
  ROSTER_UploadDutyAssignmentsLabel,
  ROSTER_UploadPharmacies,
  ROSTER_Year,
  SCORE_LINKS_NOTICE,
  SECRETARIAT_Add,
  SECRETARIAT_Address,
  SECRETARIAT_Anchors,
  SECRETARIAT_City,
  SECRETARIAT_Code,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsDayBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsNightBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_All,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Balance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculate,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculated,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayRatio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightBalance,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightRatio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_PrevActualDayDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_PrevActualNightDutyCount,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Ratio,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate,
  SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validated,
  SECRETARIAT_DASHBOARD_AnnualReviewTitle,
  SECRETARIAT_DASHBOARD_BankHolidayDateLabel,
  SECRETARIAT_DASHBOARD_BankHolidayLabel,
  SECRETARIAT_DASHBOARD_BankHolidayTitle,
  SECRETARIAT_DASHBOARD_BH_Create,
  SECRETARIAT_DASHBOARD_BH_Delete_Confirm_Text,
  SECRETARIAT_DASHBOARD_BH_Delete_Confirm_Title,
  SECRETARIAT_DASHBOARD_BH_Edit,
  SECRETARIAT_DASHBOARD_BlackPointTitle,
  SECRETARIAT_DASHBOARD_CreateStatus,
  SECRETARIAT_DASHBOARD_Discrepancy_Tab,
  SECRETARIAT_DASHBOARD_EditStatus,
  SECRETARIAT_DASHBOARD_ExchangeTitle,
  SECRETARIAT_DASHBOARD_Mediasante,
  SECRETARIAT_DASHBOARD_PlanningTitle,
  SECRETARIAT_DASHBOARD_PrefsTitle,
  SECRETARIAT_DASHBOARD_SelectBankHoliday,
  SECRETARIAT_DASHBOARD_Status,
  SECRETARIAT_DASHBOARD_SystemTitle,
  SECRETARIAT_DASHBOARD_Title,
  SECRETARIAT_DASHBOARD_Year,
  SECRETARIAT_Edit,
  SECRETARIAT_GroupsTab,
  SECRETARIAT_Language,
  SECRETARIAT_LinkPharmacy,
  SECRETARIAT_MailAddress,
  SECRETARIAT_Name,
  SECRETARIAT_PhoneNumber,
  SECRETARIAT_RefreshNeighborhood,
  SECRETARIAT_SystemStatusTab,
  SECRETARIAT_Title,
  SECRETARIAT_UsersTab,
  SECRETARIAT_Website,
  SECRETARIAT_ZipCode,
  SECRETARIATS_Title,
  SHOW_ALL_ENENT_TYPES,
  SPECIALISSUES_BLACKPOINTTRANSGRESSIONS,
  SPECIALISSUES_BP,
  SPECIALISSUES_DATE,
  SPECIALISSUES_DISP,
  SPECIALISSUES_GROUPTRANSGRESSIONS,
  SPECIALISSUES_GROUPTRANSGRESSIONSBYDATE,
  SPECIALISSUES_NAME,
  SPECIALISSUES_NIGHT_BEFORE_BP,
  SPECIALISSUES_PREFOFF,
  SPECIALISSUES_TITLE,
  SPECIALISSUES_TYPE,
  SYSTEM_STATUS_Add,
  SYSTEM_STATUS_Edit,
  SYSTEM_STATUS_SystemStatusId,
  SYSTEM_STATUS_SystemStatusName,
  SYSTEM_STATUS_SystemStatusSecretariat,
  SYSTEM_STATUS_SystemStatusValue,
  SYSTEM_STATUS_SystemStatusYear,
  TOO_CLOSE_DUTIES,
  TOO_CLOSE_DUTIES_DATE1,
  TOO_CLOSE_DUTIES_DATE2,
  TOO_CLOSE_DUTIES_DETAILS,
  TOO_CLOSE_DUTIES_DETAILS1,
  TOO_CLOSE_DUTIES_ECART,
  TOO_CLOSE_DUTIES_PHARMACY,
  TOO_CLOSE_DUTIES_PHARMACY_ANCHOR,
  TOO_CLOSE_DUTIES_PHARMACY_GROUP,
  TOO_CLOSE_DUTIES_PHARMACY_NAME,
  TOO_CLOSE_DUTIES_PHARMACYID,
  TOO_CLOSE_DUTIES_TOTAL,
  TRANSFER_AddCircleDialogTitle,
  TRANSFER_Address,
  TRANSFER_Authorized_Location,
  TRANSFER_AuthorizedLocation,
  TRANSFER_Calculate,
  TRANSFER_CalculateNewCoordinates,
  TRANSFER_CHOOSE_A_Municipality,
  TRANSFER_ClosestPharmacy,
  TRANSFER_Coordinates,
  TRANSFER_Distance,
  TRANSFER_EstimateNeighborCount,
  TRANSFER_Explore,
  TRANSFER_InsideCircle,
  TRANSFER_InsideMoveCircles,
  TRANSFER_InsidePolygon,
  TRANSFER_InvalidLocation,
  TRANSFER_Lambert,
  TRANSFER_LatLong,
  TRANSFER_MODULE_Title,
  TRANSFER_MunicipalityCreation,
  TRANSFER_MunicipalityEdition,
  TRANSFER_MunicipalityUpload,
  TRANSFER_NbrInhabitantsInZone,
  TRANSFER_NbrMaxPharmacies,
  TRANSFER_NbrMinPharmacies,
  TRANSFER_NeighborCount,
  TRANSFER_NewAddress,
  TRANSFER_NewCoordinates,
  TRANSFER_NewLambert2008Coordinates,
  TRANSFER_OutsideProtectedCircles,
  TRANSFER_PermanentProtection,
  TRANSFER_PerpendicularLength,
  TRANSFER_PharmacyEntity,
  TRANSFER_PharmacyNbrPharmacies,
  TRANSFER_PharmacyToClose,
  TRANSFER_PharmacyToKeep,
  TRANSFER_PharmacyToTransfer,
  TRANSFER_PolygonNotOptimized,
  TRANSFER_Possible_Location,
  TRANSFER_ProtectionTabTitle,
  TRANSFER_Radius,
  TRANSFER_RefDataTabTitle,
  TRANSFER_RemoveCircleDialogTitle,
  TRANSFER_REQUEST_decision,
  TRANSFER_REQUEST_decisionDate,
  TRANSFER_REQUEST_firstPublishAfterDecisionDate,
  TRANSFER_REQUEST_firstPublishDate,
  TRANSFER_REQUEST_initialAddress,
  TRANSFER_REQUEST_initialCity,
  TRANSFER_REQUEST_initialZipCode,
  TRANSFER_REQUEST_newAddress,
  TRANSFER_REQUEST_newCity,
  TRANSFER_REQUEST_newZipCode,
  TRANSFER_REQUEST_procedure,
  TRANSFER_REQUEST_requestDate,
  TRANSFER_RequestTabTitle,
  TRANSFER_SelectedLat,
  TRANSFER_SelectedLng,
  TRANSFER_SelectedRadius,
  TRANSFER_Show100mCircle,
  TRANSFER_ShowCircleDialogTitle,
  TRANSFER_ShowCircles,
  TRANSFER_ShowDefaultProtectionCircles,
  TRANSFER_ShowIntersection,
  TRANSFER_ShowPerpendiculars,
  TRANSFER_ShowPolygons,
  TRANSFER_ShowProtectionCircles,
  TRANSFER_ShowRadius,
  TRANSFER_ShowTemporaryProtectionCircles,
  TRANSFER_SimpleFusionTabTitle,
  TRANSFER_SimpleTransferTabTitle,
  TRANSFER_SwitchSearchByLambert2008,
  TRANSFER_TemporaryProtection,
  TRANSFER_TerminateProtection,
  TRANSFER_TransferWithFusionTabTitle,
  TRANSFER_Unauthorized_Location,
  TRANSFER_UploadMunicipalities,
  TRANSFER_UploadPopulations,
  TRANSFER_UploadZipCodes,
  TRANSFER_UploadZipCodesBpost,
  TRANSFER_UploadZipCodesStatbel,
  TRANSFER_ValidLocation,
  TRANSFER_within100Meters,
  TRANSFER_ZoomClose,
  TRANSFER_ZoomDestination,
  TRANSFER_ZoomHalfHalf,
  TRANSFER_ZoomNeighbors,
  TRANSFER_ZoomPharmacy,
  TRANSFER_ZoomPharmacyKeep,
  TRANSFER_ZoomPolygon,
  UNAVAILABILITY_AuthorizeLogin,
  UNAVAILABILITY_LimitLogin,
  UNAVAILABILITY_LoginStatus,
  UNAVAILABILITY_MinimalLogin,
  UNAVAILABILITY_Title,
  UNBALANCED_NEIGHBORS_COMMENTS,
  UNBALANCED_NEIGHBORS_DAY_STATS,
  UNBALANCED_NEIGHBORS_DAYS,
  UNBALANCED_NEIGHBORS_DAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_DAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_DETAILS,
  UNBALANCED_NEIGHBORS_FRIDAY_STATS,
  UNBALANCED_NEIGHBORS_FRIDAYS,
  UNBALANCED_NEIGHBORS_FRIDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_FRIDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_GRAPHS_TITLE,
  UNBALANCED_NEIGHBORS_HOLIDAY_STATS,
  UNBALANCED_NEIGHBORS_HOLIDAYS,
  UNBALANCED_NEIGHBORS_HOLIDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_HOLIDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_LIST_TITLE,
  UNBALANCED_NEIGHBORS_NIGHT_STATS,
  UNBALANCED_NEIGHBORS_NIGHTS,
  UNBALANCED_NEIGHBORS_NIGHTS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_NIGHTS_TOOLTIP,
  UNBALANCED_NEIGHBORS_PHARMACY_APB,
  UNBALANCED_NEIGHBORS_PHARMACY_NAME,
  UNBALANCED_NEIGHBORS_PHARMACYID,
  UNBALANCED_NEIGHBORS_SATURDAY_STATS,
  UNBALANCED_NEIGHBORS_SATURDAYS,
  UNBALANCED_NEIGHBORS_SATURDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_SATURDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_SUNDAY_STATS,
  UNBALANCED_NEIGHBORS_SUNDAYS,
  UNBALANCED_NEIGHBORS_SUNDAYS_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_SUNDAYS_TOOLTIP,
  UNBALANCED_NEIGHBORS_TITLE,
  UNBALANCED_NEIGHBORS_TOTAL,
  UNBALANCED_NEIGHBORS_TOTAL_STAT_TOOLTIP,
  UNBALANCED_NEIGHBORS_TOTAL_STATS,
  UNBALANCED_NEIGHBORS_TOTAL_TOOLTIP,
  UNBALANCED_NEIGHBORS_YEAR_HOLIDAYS,
  UNBALANCED_NEIGHBORS_YEAR_SUNDAYS,
  UNBALANCED_NEIGHBORS_YEAR_SUNDAYS_TOOLTIP,
  UNEVEN_DUTY_INTERVALS,
  USER_Goto_Pharmacy,
  USER_Goto_User,
  USER_Impersonate,
  USER_Is_Active,
  USER_Registration,
  USER_Registration_Address,
  USER_Registration_Category,
  USER_Registration_Organization,
  USER_Registration_PhoneNumber,
  USER_Registration_Request,
  USER_Registration_Role,
  USER_Title,
  USER_Warning_Select_Pharmacy,
  USER_Warning_Select_Secretariat,
  USER_WarningInvalidRoles,
  USERS_Title,
}
